<template>
  <div class="olympic-carousel-wrapper">
    <div class="olympic-carousel-inner" :style="animaStyleObj" :class="[hasTrans ? 'trans' : '']">
      <div
        v-for="(item, index) in videos"
        :key="item.title"
        class="item"
        :class="[cur === index ? 'active' : '', hasTrans ? 'trans' : '']"
      >
        <img :src="item.url" />
        <div class="title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { KdPopup, KdButton } from 'kuaidong-ui'
import { BaseComponent, Component } from 'kuaidong-component'
import { Debounce } from 'kuaidong-lib'
import img1 from './assets/bubble-1.png'
import img2 from './assets/bubble-2.png'
import img3 from './assets/bubble-3.png'

@Component({
  components: {
    KdPopup,
    KdButton,
  },
})
export default class Carousel extends BaseComponent {
  videos: any[] = [
    {
      url: img1,
      title: 'img1',
    },
    {
      url: img2,
      title: 'img2',
    },
    {
      url: img3,
      title: 'img3',
    },
    {
      url: img1,
      title: 'img4',
    },
    {
      url: img2,
      title: 'img5',
    },
    {
      url: img3,
      title: 'img6',
    },
  ]
  cur = 2
  hasTrans = true
  si: any = null
  get animaStyleObj() {
    return {
      transform: `translateX(${this.$px(this.cur * -260)}px)`,
    }
  }
  beforeDestroy() {
    clearInterval(this.si)
  }
  mounted() {
    this.$nextTick(() => {
      clearInterval(this.si)
      this.si = setInterval(() => {
        this.handleRightClick()
      }, 3000)
    })
  }
  @Debounce(300)
  handleLeftClick() {
    // if (this.cur === 0) return
    // 先将最后一个放到第一个
    this.hasTrans = false
    this.videos = this.videos
      .slice(this.videos.length - 1, this.videos.length)
      .concat(this.videos.slice(0, this.videos.length - 1))
    this.cur = this.cur + 1
    // 数据整理结束后，再设置cur，构造动画
    setTimeout(() => {
      this.hasTrans = true
      this.cur--
    }, 0)
  }
  @Debounce(300)
  handleRightClick() {
    // if (this.cur === this.videos.length - 1) return
    // 先将第一个放到最后
    this.hasTrans = false
    this.videos = this.videos.slice(1, this.videos.length).concat(this.videos.slice(0, 1))
    this.cur = this.cur - 1
    // 数据整理结束后，再设置cur，构造动画
    setTimeout(() => {
      this.hasTrans = true
      this.cur++
    }, 0)
  }
}
</script>

<style lang="less" scoped>
.olympic-carousel-wrapper {
  width: 260px;
  height: 100px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  > .olympic-carousel-inner {
    display: flex;
    align-items: center;
    height: 100px;
    // transform: translateX(88.5px);
    &.trans {
      transition: all 1.2s;
    }
    > .item {
      flex: none;
      width: 260px;
      height: 100px;
      // border-radius: 5px;
      // box-shadow: 0px 4px 29.5px 0px #00000040;
      &.active {
        position: relative;
        // z-index: 2;
        // transform: scale(1.2);
        // > .title {
        //   visibility: visible;
        //   opacity: 1;
        // }
        // box-shadow: 0px 4px 29.5px 0px #00000040;
      }
      &.trans {
        transition: all 1.2s;
      }
      > img {
        width: 100%;
        // border-radius: 5px;
      }
      > .title {
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-weight: 700;
        line-height: 21px;
        text-align: center;
        margin: 10px 0;
        color: #818181;
        // visibility: hidden;
        opacity: 0;
        transition: all 1.2s;
      }
    }
  }
  > .olympic-carousel-btn-left {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    > img {
      width: 30px;
      height: 30px;
    }
  }

  > .olympic-carousel-btn-right {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    > img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
